/**
 * Formata datas UTC do banco para timezone local
 * Formato esperado: "2026-03-16 20:34:28"
 * @param {string} dateStr - Data em formato "YYYY-MM-DD HH:mm:ss"
 * @returns {string} Data formatada em pt-BR com timezone local
 */
export function formatDateTimeLocal (dateStr) {
  if (!dateStr) return ''

  try {
    // Converte "2026-03-16 20:34:28" para "2026-03-16T20:34:28Z"
    const isoString = dateStr.replace(' ', 'T') + 'Z'
    const dateObj = new Date(isoString)

    if (isNaN(dateObj.getTime())) {
      return dateStr
    }

    // O Date já converte UTC para timezone local ao formatar com toLocaleString
    return dateObj.toLocaleString('pt-BR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
  } catch (e) {
    console.error('Erro ao formatar data:', e)
    return dateStr
  }
}
